import { SET_BROWSER_HISTORY } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function setBrowserHistory(history) {
  return callingAPIMethodWithQueue(SET_BROWSER_HISTORY, history);
}